import React from "react";
import { motion } from "framer-motion";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

const UserDetails = ({ user }) => {
  const signInHistory = [
    { name: "Feb", signIn: 2 },
    { name: "Mar", signIn: 4 },
    { name: "Apr", signIn: 6 },
    { name: "May", signIn: 8 },
    { name: "Jun", signIn: 3 },
    { name: "Jul", signIn: 7 },
    { name: "Aug", signIn: 5 },
    { name: "Oct", signIn: 10 },
    { name: "Nov", signIn: 11 },
    { name: "Dec", signIn: 12 },
  ];

  return (
    <motion.div
      className="w-full mt-8 bg-white rounded-lg sh"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Activity Chart */}
      <motion.div
        className="mt-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2 className="mb-4 text-xl font-semibold text-gray-700">
          User Activity
        </h2>
        <LineChart width={600} height={300} data={signInHistory}>
          <Line type="monotone" dataKey="signIn" stroke="#8884d8" />
          <CartesianGrid stroke="#ccc" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
        </LineChart>
      </motion.div>
    </motion.div>
  );
};

export default UserDetails;
